import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import { withdrawInvestment } from "../../utils/callHelpers";
import { getCloudStakingContract } from "../../utils/contractHelpers";
import useWeb3 from "../useWeb3";

export const useWithdrawToken = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const contract = getCloudStakingContract(web3);

  const handleWithdrawToken = useCallback(
    async (pid) => {
      const txHash = await withdrawInvestment(account, contract, pid);
      return txHash;
    },
    [account, contract]
  );

  return { onWithdrawToken: handleWithdrawToken };
};
